import React, { createContext, useCallback, useContext, useEffect } from 'react';

import { useMember } from 'hooks/useMember';

import Sidebar from 'components/Sidebar';
import SidebarMobile from 'components/SidebarMobile';

import { getThemeByTier, getClassWithTheme, ThemeMode } from 'helpers';

import AccountDataSections from './AccountDataSections';
import { QuickAccess } from './QuickAccess';

const ThemeContext = createContext<ThemeMode>('light');
export const useTheme = () => useContext(ThemeContext);

const getColorByTier = (tier: string) => {
  const tierParsed = tier.toLowerCase().replace(' ', '');

  if (tierParsed === 'essencial') {
    return '#e65200';
  }

  if (tierParsed === 'prime') {
    return '#737373';
  }

  if (tierParsed === 'superprime') {
    return '#c6a76e';
  }
  return '#ff7020';
};

const MyAccount = () => {
  const { userData, tierData, isClubSmls, isValeMilhas } = useMember();
  const themeMode: ThemeMode = getThemeByTier(userData?.tier);
  useEffect(() => {
    if (themeMode === 'dark') {
      const headerElement = document.querySelector('.header') as HTMLElement;
      const liferayHeaderElement = document.querySelector('.liferay-header-my-account') as HTMLElement;
      const liferayElement = document.getElementById('wrapper') as HTMLElement;

      if (headerElement) {
        headerElement.style.backgroundColor = '#000000';
        headerElement.classList.add('dark');
      }

      if (liferayHeaderElement) {
        liferayHeaderElement.style.backgroundColor = '#000000';
        liferayHeaderElement.classList.add('dark');
      }

      if (liferayElement) {
        liferayElement.classList.add('exclusive-dark');
      }
    }
  }, [themeMode]);

  const checkIfIsExclusive = useCallback((tier: string) => {
    const defaultIcon = document.querySelector('.header_content #icon-my-account-default') as HTMLElement;
    const exclusiveIcon = document.querySelector('.header_content #icon-my-account-exclusive') as HTMLElement;

    if (!defaultIcon || !exclusiveIcon) return;

    if (tier === 'exclusive') {
      defaultIcon.style.display = 'none';
      exclusiveIcon.style.display = 'block';
      return;
    }
    defaultIcon.style.display = 'block';
    exclusiveIcon.style.display = 'none';
  }, []);

  useEffect(() => {
    const svgElements = document.querySelectorAll<HTMLElement>('.header_content_icon svg g path');

    if (userData && svgElements) {
      Array.from(svgElements).forEach((svgElement) => {
        const svgElementMod = svgElement;
        svgElementMod.style.fill = getColorByTier(userData.tier);
      });

      checkIfIsExclusive(userData.tier);
    }
  }, [userData, checkIfIsExclusive]);

  if (!tierData || !userData) return null;

  const { memberNumber } = tierData.userInfo;
  const isExclusive = userData.tier.toLowerCase() === 'exclusive';

  return (
    <ThemeContext.Provider value={themeMode}>
      <div className={getClassWithTheme('my-account__wrapper', themeMode)}>
        <div className="my-account__container">
          <div className="my-account__container__content">
            <Sidebar
              user={userData.socialReason}
              voeBizNumber={memberNumber}
              tier={userData.tier}
              isClubSmls={isClubSmls}
              tierData={tierData}
              isValeMilhas={isValeMilhas}
            />
            <SidebarMobile
              user={userData.socialReason}
              voeBizNumber={memberNumber}
              tier={userData.tier}
              isClubSmls={isClubSmls}
              tierData={tierData}
              isValeMilhas={isValeMilhas}
            />
            <AccountDataSections tierData={tierData} userData={userData} isClubSmls={isClubSmls} />
          </div>
          {isExclusive && <QuickAccess />}
        </div>
      </div>
    </ThemeContext.Provider>
  );
};

export default MyAccount;
